import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';
import {
    getCalendarOptions,
    saveCalendarProcessingOptions,
    updateCalendarProcessingOptions,
} from 'owa-calendar-processing-configuration';
import getForwardMeetingNotificationOption from '../selectors/getForwardMeetingNotificationOption';
import getOldMeetingMessgeOption from '../selectors/getOldMeetingMessageOption';
import logDataOnSaveInvitations from '../utils/logDataOnSaveInvitations';

/*
    Called when clicked on save button in calendar settings panel.
    Updates user options so that the changes are reflected in current user session
    Updates the calendar processing configuration on local store and on server
*/

export default async function saveInvitationOption() {
    const calendarProcessingConfiguration: CalendarProcessingOptions = getCalendarOptions();

    let newOldMeetingMessagesStatus = getOldMeetingMessgeOption();
    let newForwardedMeetingNotificationsStatus = getForwardMeetingNotificationOption();

    updateCalendarProcessingOptions({
        RemoveOldMeetingMessages: newOldMeetingMessagesStatus,
        RemoveForwardedMeetingNotifications: newForwardedMeetingNotificationsStatus,
    });

    // save the new calendar configuration at server
    await saveCalendarProcessingOptions(calendarProcessingConfiguration);
    logDataOnSaveInvitations();
}
